export const makeSelectType = ({ label, value }) => {
  return {
    label: label,
    value: value ? value : label,
  };
};
